import { render, staticRenderFns } from "./HelloUser.vue?vue&type=template&id=454435a1&scoped=true"
import script from "./HelloUser.vue?vue&type=script&lang=ts"
export * from "./HelloUser.vue?vue&type=script&lang=ts"
import style0 from "./HelloUser.vue?vue&type=style&index=0&id=454435a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454435a1",
  null
  
)

export default component.exports